import React from 'react';
import PropTypes from "prop-types";

export default function WrapperValidationInputGroup(WrappedComponent, wrapped) {
    return class extends React.Component {
        constructor(props) {
            super(props);
            this.handleChange = this.handleChange.bind(this);
            this.handleBlur = this.handleBlur.bind(this);
            this.handleValidators = this.handleValidators.bind(this);
            this.state = {
                validate: {
                    on: props.validateOn,
                    validators: wrapped.validators
                }
            };
        }

        handleChange(e) {
            const value = e.target ? e.target.value : e;
            this.props.onChange(value);
            if (this.state.validate.on === "change" || this.state.validate.on === undefined) {
                this.handleValidators(value);
            }
        }

        handleBlur(e) {
            const value = e.target ? e.target.value : e;
            this.props.onBlur(value);
            if (this.state.validate.on === "blur") {
                this.handleValidators(value);
            }
        }

        handleValidators(value) {
            let alert = Object.assign(this.props.alert);
            alert.show = false;
            for (let i in this.state.validate.validators) {
                this.state.validate.validators[i].setInput(value);
                if (!this.state.validate.validators[i].isValid()) {
                    alert.show = true;
                    alert.type = "error";
                    alert.text = this.state.validate.validators[i].message();
                    break;
                }
            }
            this.props.onAlertUpdate(alert);
        }

        render() {
            return (
                <WrappedComponent {...this.props} onClick={this.props.onAlertUpdate} onChange={this.handleChange} onBlur={this.handleBlur}/>
            )
        }
    }
}

WrapperValidationInputGroup.propTypes = {
    input: PropTypes.shape({
        label: PropTypes.object.isRequired,
    }).isRequired,
    alert: PropTypes.shape({
        show: PropTypes.bool.isRequired,
        title: PropTypes.string,
        text: PropTypes.string,
        type: PropTypes.string,
        dismissible: PropTypes.bool,
    }),
    onAlertUpdate: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
};


// WEBPACK FOOTER //
// ./src/input/validation/WrapperValidationInputGroup.js